export class BettingTypesService {
	
}